module.exports = __webpack_public_path__ + "static/media/interiorImage3-min.a685dbe6.jpg";